<template>
<div>
    
    <v-dialog
      v-model="cropDialog"
      :fullscreen="($vuetify.breakpoint.xs) ? true : false"
      width="50%"
      :retain-focus="false"
      @click:outside="closeCrop"
    >
    <v-card>
        <v-card-text class="text-center">
        <OverLay/>
    <cropper
    class="cropper"
    :src="imgCrop.image_url"
    :canvas="false"
    @change="changeCrop"
  ></cropper>
  <v-btn class="primary ma-1" @click="cropIMG">Enregistrer</v-btn>
</v-card-text>
</v-card>
</v-dialog>

<v-dialog
      v-model="replaceDialog"
      :fullscreen="($vuetify.breakpoint.xs) ? true : false"
      width="50%"
      :retain-focus="false"
      @click:outside="closeReplace"
    >
    <v-card>
        <v-card-text class="text-center">
        <OverLay/>
        <v-row no-gutter align="center" justify="center">
            <v-col align="center" justify="center" class="col-5"><img :src="displayImg(replaceImage)" width="100" weight="200"></v-col>
            <v-col align="center" justify="center" class="col-2"><v-icon x-large class="text-h1">mdi-swap-horizontal</v-icon></v-col>
            <v-col align="center" justify="center" class="col-5">
                <v-file-input
                label="Importer le fichier"
                v-model="fileReplace"
                required
                accept=".jpg,.jpeg,.png,.webp,.gif,.bmp"
                outlined
                filled
                clearable
                class="ma-0 pa-0"
                ></v-file-input> 
            </v-col>
        </v-row>
        <v-row no-gutter align="center" justify="center">
            <v-col class="text-center">
                <v-btn class="primary ma-1" @click="replaceIMG">Enregistrer</v-btn>
            </v-col>
        </v-row>
    </v-card-text>
</v-card>
</v-dialog>

    <v-row>
        <v-col>
            <v-text-field
            label="Rechercher dans la bibliothèque"
            v-model="searchImage"
            @keyup.enter="getSearch"
            @input="scheduleSearch"
            @click:clear="()=> {searchImage=''; getSearch() }"
            clearable
        
          ></v-text-field>       
        </v-col>
        <v-col class="text-center">

            <v-file-input
            label="Importer un fichier"
            v-model="chosenFile"
            required
            accept=".jpg,.jpeg,.png,.webp,.gif,.bmp"
            outlined
            filled
            clearable
            class="ma-0 pa-0"
            ></v-file-input>     
            <v-btn @click="uploadFile" small>Telecharger l'image</v-btn>            
        </v-col>
    </v-row>
    <v-row no-gutters>
        <v-col>
        <ul style="list-style-type: none;">
            <li v-for="(pic,d) in datas.display" :key="d" class="liimg">
                <v-hover v-slot="{ hover }">
                    <template>
                        <v-card width="150" weight="100" class="rounded text-center">

                                    <v-overlay
                                    absolute
                                    :value="hover"
                                    :opacity="0.2"
                                    >
                                    <span v-for="(list, i) in pic.actions" :key="i" class="d-inline-flex align-center">
                                    <v-btn small :icon="list.icon" class="primary ma-1" @click="onClickButton(pic,list)" :title="list.name"><v-icon v-if="list.icon" small>{{list.icon}}</v-icon><span v-else>{{ list.name }}</span></v-btn>
                                    <rights-indicator :checks="actionInspectionChecks(list)" :label="list.name" />
                                    </span>
                                    <v-btn v-show="pic.image_id && pic.type_file == 'image'" small icon class="primary ma-1" @click="() => {imgCrop=pic; cropDialog=true}" title="couper"><v-icon small>mdi-crop</v-icon></v-btn>
                                    <v-btn small icon class="primary ma-1" @click="()=> {replaceDialog=true; replaceImage=pic}" title="remplacer"><v-icon small>mdi-sync</v-icon></v-btn>
                                    <v-btn small v-show="pic.image_id" icon class="primary ma-1" @click="copyImageUrl(pic)" title="copier le lien"><v-icon small>mdi-content-copy</v-icon></v-btn>
                                    <v-btn small icon v-show="pic.image_id" class="red ma-1" @click="()=> {deleteImg(pic.image_id)}" title="supprimer"><v-icon small>mdi-trash-can</v-icon></v-btn>
                                    <v-btn x-small v-show="pic.image_id && params.allowselect" class="primary ma-1" @click="selection(pic)">Selectionner</v-btn>
                                    </v-overlay>

                                <img :src="displayImg(pic)" class="imginli">
                                <div class="nameimg">{{pic.name}}</div>
                        </v-card>
                        
                    </template>
                </v-hover>

            </li>
        </ul>
    </v-col>
    </v-row>
</div>
    </template>
    
    
    
    <script>
import { Cropper } from 'vue-advanced-cropper'
import { client } from '../mixins'; 
import 'vue-advanced-cropper/dist/style.css';
        export default {

            name : 'bibliModule',

            components: {
                Cropper,
                OverLay: () => import('@/components/outils/overlay.vue')
            },
            mixins : [client],

            data: function() {
    
                return {
                    AllowedDisplay : true,
                    show : false,
                    listButtons : [],
                    datas : {all:[],display:[]},
                    no_image : '',
                    chosenFile : null,
                    searchImage:'',
                    cropDialog : false,
                    imgCrop : {},
                    paramsCrop:{},
                    replaceDialog : false,
                    replaceImage : {},
                    fileReplace : null,
                    params:{},
                    querys:{},
                    debounceTimeout: null,
                }
            },

        watch : {
            showMod: {
            // permet de rafraichir quand la modal de la page se ferme
            handler(val) {
                if (val.show === false) {
                    this.callAPI()
                }
            },
            deep: true,
            }
        },

            methods :  {   
                
            displayImg(pic) {
            // Image normale
            if (!pic.type_file || pic.type_file === 'image') {
                return pic.image_url || this.no_image
            }

            if (pic.type_file === 'file') {
                const ext = pic.ext?.toLowerCase()

                const icons = {
                pdf: 'https://img.icons8.com/color/96/pdf.png',

                doc: 'https://img.icons8.com/color/96/microsoft-word-2019--v1.png',
                docx: 'https://img.icons8.com/color/96/microsoft-word-2019--v1.png',

                xls: 'https://img.icons8.com/color/96/microsoft-excel-2019--v1.png',
                xlsx: 'https://img.icons8.com/color/96/microsoft-excel-2019--v1.png',

                ppt: 'https://img.icons8.com/color/96/microsoft-powerpoint-2019--v1.png',
                pptx: 'https://img.icons8.com/color/96/microsoft-powerpoint-2019--v1.png',

                csv: 'https://img.icons8.com/color/96/csv.png',
                txt: 'https://img.icons8.com/color/96/txt.png',
                zip: 'https://img.icons8.com/color/96/zip.png'
                }

                return icons[ext] || 'https://img.icons8.com/color/96/file.png'
            }

            return this.no_image
            },
    
                callAPI : function() {
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,querys:this.querys}}).then((resp) => {

                        this.manageDatas(resp.data)
                            
                    })
    
                },   
                
                manageDatas(data) {
                    if(!data.success) {
                            this.AllowedDisplay = false; 
                            this.$toast.error(data.message)
                            return false;
                            }
                            this.datas.all = data.pictures;
                            this.datas.display = data.pictures;
                            this.no_image = data.no_image
                            this.show = true 
                },

                appendFormData(formData, value, path) {
                    if (value === undefined || value === null) {
                        return
                    }

                    if (Array.isArray(value)) {
                        value.forEach((item, index) => {
                            this.appendFormData(formData, item, `${path}[${index}]`)
                        })
                        return
                    }

                    if (typeof value === 'object' && !(value instanceof File)) {
                        Object.keys(value).forEach(key => {
                            this.appendFormData(formData, value[key], `${path}[${key}]`)
                        })
                        return
                    }

                    formData.append(path, value)
                },

                async prepareImageForUpload(file) {
                    if (!file) return file

                    const extension = (file.name.split('.').pop() || '').toLowerCase()
                    const supportedExtensions = ['jpg', 'jpeg', 'png', 'webp', 'bmp']

                    // Ne pas transformer les GIF : le canvas supprimerait l'animation.
                    if (extension === 'gif' || !supportedExtensions.includes(extension)) {
                        return file
                    }

                    let source = null
                    let objectUrl = null

                    try {
                        if (typeof createImageBitmap === 'function') {
                            try {
                                source = await createImageBitmap(file, { imageOrientation: 'from-image' })
                            } catch (error) {
                                source = await createImageBitmap(file)
                            }
                        } else {
                            objectUrl = URL.createObjectURL(file)
                            source = await new Promise((resolve, reject) => {
                                const image = new Image()
                                image.onload = () => resolve(image)
                                image.onerror = () => reject(new Error('Image illisible'))
                                image.src = objectUrl
                            })
                        }

                        const sourceWidth = source.width || source.naturalWidth
                        const sourceHeight = source.height || source.naturalHeight
                        const maxWidth = 1600
                        const maxHeight = 2263
                        const ratio = Math.min(maxWidth / sourceWidth, maxHeight / sourceHeight, 1)
                        const width = Math.max(1, Math.round(sourceWidth * ratio))
                        const height = Math.max(1, Math.round(sourceHeight * ratio))
                        const canvas = document.createElement('canvas')
                        canvas.width = width
                        canvas.height = height

                        const context = canvas.getContext('2d')
                        if (!context) return file
                        context.drawImage(source, 0, 0, width, height)

                        const outputType = extension === 'png'
                            ? 'image/png'
                            : (extension === 'webp' ? 'image/webp' : 'image/jpeg')
                        const quality = outputType === 'image/png' ? undefined : 0.82
                        const blob = await new Promise(resolve => canvas.toBlob(resolve, outputType, quality))

                        if (!blob) return file

                        const actualType = blob.type || outputType
                        const outputExtension = actualType === 'image/png'
                            ? 'png'
                            : (actualType === 'image/webp' ? 'webp' : 'jpg')
                        const baseName = file.name.replace(/\.[^.]+$/, '')

                        return new File([blob], `${baseName}.${outputExtension}`, {
                            type: actualType,
                            lastModified: file.lastModified || Date.now(),
                        })
                    } catch (error) {
                        // Le traitement serveur reste disponible en secours.
                        return file
                    } finally {
                        if (source && typeof source.close === 'function') source.close()
                        if (objectUrl) URL.revokeObjectURL(objectUrl)
                    }
                },

                uploadFile : async function() {
                    if(!this.chosenFile) {
                        this.$toast.warning('Veuillez sélectionner un fichier avant d\'importer')
                        return false;
                    }
                    this.$store.dispatch('textOverlay','Importation en cours');
                    this.$store.dispatch('getoverlay', true)
                    const preparedFile = await this.prepareImageForUpload(this.chosenFile)
                    const formData = new FormData();
                    formData.append('importFile', preparedFile);
                    formData.append('id', this.idmodule);
                    this.appendFormData(formData, this.params ?? {}, 'params');
                    this.appendFormData(formData, this.querys ?? {}, 'querys');

                    this.API({type:'post', url:'displaymodule', params:formData, apidefault:{headers:{'Content-Type':'multipart/form-data'}}}).then((resp) => {
                        this.$store.dispatch('getoverlay', false)
                            if(!resp.data.success) {
                            this.$toast.warning(resp.data.message) 
                            return false;
                            }
                            this.$toast.success('importation réussie');
                            this.chosenFile = null
                            this.datas.all = resp.data.pictures;
                            this.datas.display = resp.data.pictures;

                            
                    })
    
                },   

                scheduleSearch() {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => this.getSearch(), 500);
                },

                getSearch() {
                    let result = JSON.parse(JSON.stringify(this.datas.all));
                    if (!this.searchImage) {
                        this.datas.display = this.datas.all;
                        return 
                    }

                    const filterValue = this.searchImage.toLowerCase()

                    const filter = event => event.name.toLowerCase().includes(filterValue)

                    this.datas.display = result.filter(filter)

                },

                onClickButton: function (fromSelected, men) {
                if(men.target=='modal') this.fromThisMod = true;
                this.clickActions({args:fromSelected,action:men,idmodule:this.idmodule,modalKey:this.modalKey,page:this.page,
                success:(datas) => {
                    if(datas.message) this.$toast.success(datas.message);
                    //if(men.typelink == 'api') this.callAPI();
                }    
                })

                },

                getAction(pic,action) {
                    var getReplace = {}
                if (action.typelink == 'link') {

                    action.get.forEach((v) => {
                    if (v.type == 'table' || v.type == '') {
                        getReplace[v.key] = pic[v.value]
                    } else {
                        getReplace[v.key] = this.replaceBy({ text: v.value, page: this.modalKey });
                    }

                    })

                    this.goTo({ modalKey:this.modalKey, name: action.page_name, type: action.target, replace: getReplace, paramDialog: action.paramdialog})
                }



                if (action.typelink == 'api') {
                    if(action.params.ifconfirm && action.params.ifconfirm!='') {
                        if(confirm(action.params.ifconfirm)) {
                            this.API({ type: action.params.apilink.type, url: this.replaceBy({ text: action.params.apilink.url, page: this.modalKey, line:pic }), params: pic }).then((resp) => {
                            if(resp.data.success) {
                                if(resp.data.message) this.$toast.success(resp.data.message);
                                this.callAPI()
                            } else {
                                this.$toast.error(resp.data.message);
                            }
                            });
                        }
                    } else {
                    this.API({ type: action.params.apilink.type, url: this.replaceBy({ text: action.params.apilink.url, page: this.modalKey, line:pic }), params: pic }).then((resp) => {
                        if(resp.data.success) {
                        if(resp.data.message) this.$toast.success(resp.data.message);
                            this.callAPI()
                        } else {
                        this.$toast.error(resp.data.message);
                        }        
                    });          
                    }
                }
                },

                changeCrop({coordinates}) {
                    this.paramsCrop = coordinates
                },

                cropIMG() {
                    this.$store.dispatch('textOverlay','Redimensionnement en cours');
                    this.$store.dispatch('getoverlay', true)
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,crop:this.paramsCrop,image:this.imgCrop.image_id}}).then((resp) => {

                    this.$store.dispatch('getoverlay', false)

                    if(!resp.data.success) {
                    this.AllowedDisplay = false; 
                    return false;
                    }
                    this.datas.all = resp.data.pictures;
                    this.datas.display = resp.data.pictures;
                    this.closeCrop()
                    })
                },

                closeCrop() {
                    this.cropDialog=false; 
                    this.imgCrop={}
                },

                async replaceIMG() {
                    if(!this.fileReplace) {
                        this.$toast.warning('Veuillez sélectionner un fichier avant de remplacer l\'image')
                        return false
                    }
                    this.$store.dispatch('textOverlay','Remplacement en cours');
                    this.$store.dispatch('getoverlay', true)
                    const preparedFile = await this.prepareImageForUpload(this.fileReplace)
                    const formData = new FormData();
                    formData.append('fileReplace', preparedFile);
                    formData.append('id', this.idmodule);
                    formData.append('origin', JSON.stringify(this.replaceImage));
                    this.appendFormData(formData, this.params ?? {}, 'params');
                    this.appendFormData(formData, this.querys ?? {}, 'querys');
                    this.API({type:'post', url:'displaymodule', params:formData, apidefault:{headers:{'Content-Type':'multipart/form-data'}}}).then((resp) => {
                        this.$store.dispatch('getoverlay', false)
                            if(!resp.data.success) {
                            this.$toast.warning(resp.data.message) 
                            return false;
                            }
                            this.$toast.success('Remplacement effectué');
                            this.closeReplace()
                            this.datas.all = resp.data.pictures;
                            this.datas.display = resp.data.pictures;

                            
                    })                   
                },

                copyImageUrl(pic) {
                    const link = pic && pic.image_url ? pic.image_url : '';
                    if(!link) {
                        this.$toast && this.$toast.warning('Aucune URL disponible');
                        return;
                    }
                    const notifySuccess = () => { this.$toast && this.$toast.success('Lien copié'); };
                    const notifyError = () => { this.$toast && this.$toast.error('Impossible de copier le lien'); };
                    if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
                        navigator.clipboard.writeText(link).then(notifySuccess).catch(notifyError);
                        return;
                    }
                    try {
                        const textarea = document.createElement('textarea');
                        textarea.value = link;
                        textarea.setAttribute('readonly', '');
                        textarea.style.position = 'absolute';
                        textarea.style.left = '-9999px';
                        document.body.appendChild(textarea);
                        textarea.select();
                        const successful = document.execCommand('copy');
                        document.body.removeChild(textarea);
                        if(successful) {
                            notifySuccess();
                        } else {
                            notifyError();
                        }
                    } catch (err) {
                        notifyError();
                    }
                },

                deleteImg(id) {
                    if(confirm('Vous allez supprimer cette image, confirmer ?')) {
                    this.$store.dispatch('textOverlay','Suppression en cours');

                        this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,delete:true,image:id}}).then((resp) => {
                            this.$store.dispatch('getoverlay', false)
                            if(!resp.data.success) {
                                this.$toast.error(resp.data.message) 
                            } else {
                                this.datas.display = this.datas.display.filter(el => el.image_id!=id);
                                this.$toast.success(resp.data.message)    
                            }
                        })
                    }
                },

                closeReplace() {
                    this.replaceDialog=false; 
                    this.replaceImage={};
                    this.fileReplace = null
                },

                selection(pic) {

                    this.$store.dispatch('setPicture',pic);

                }
                
            },
            mounted() {
                
                this.params = this.$store.getters.specificPage(this.modalKey)?.params??{}    
                this.querys = this.$route.query;
                if(this.customparams) this.params = this.customparams
                if(this.hook == 'search') this.querys.global = this.$store.getters.getStringSearch;

                let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                } 

            },
    
            created() {  

            }
    
        }
    
    </script>


<style scoped>
.cropper {
  height: 500px;
  background: #DDD;
}

.liimg {
    position:relative;
    float: left;
    margin: 5px;
    min-width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
}
.liimg img {
    display: flex;
    justify-content: center;
}
.nameimg {
position:absolute;
bottom:0;
width:100%;
background-color:rgba(128, 128, 128, 0.301)
}
.imginli {
    position: absolute;
    width: 100%; /* Remplit toute la largeur */
    height: 100%; /* Remplit toute la hauteur du div */
    object-fit: contain; /* Garde le ratio sans dépasser */
}
</style>
